import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { ReportItemType, ReportType } from "../helpers/types";
import { useAuthContext } from "./AuthProvider";
import FullscreenLoader from "../components/FullscreenLoader";
import { useLocation, useParams } from "react-router-dom";

type ContextType = {
    report: ReportItemType | null;
    reportConfig: ReportType | null;
}

const ReportContext = createContext<ContextType | null>(null);
const useReportContext = () => {
    const context = useContext(ReportContext);
    if (context === null) {
        throw new Error("useReportContext must be used within a ReportProvder");
    }

    return context;
}

const ReportProvider = ({ children }: { children: ReactNode }) => {
    const { apiCall } = useAuthContext();
    const [report, setReport] = useState<ReportItemType | null>(null);
    const [reportConfig, setReportConfig] = useState<ReportType | null>(null);

    const location = useLocation();
    const params = useParams();

    const getReportDetails = async () => {
        const response = await apiCall({
            action: 'getReportById',
            id: params.reportId
        });

        if (response.data.status === 200) {
            setReport(response.data.data)
            setReportConfig(response.data.config)
        }
    }

    useEffect(() => {
        getReportDetails();
    }, [location])

    return (
        <ReportContext.Provider value={{
            report,
            reportConfig
        }}>
            {report ? children : <FullscreenLoader />}
        </ReportContext.Provider>
    )
}

export { useReportContext, ReportProvider }